import { render, staticRenderFns } from "./LocationBanner.vue?vue&type=template&id=2d8debdc&scoped=true"
import script from "./LocationBanner.vue?vue&type=script&lang=ts"
export * from "./LocationBanner.vue?vue&type=script&lang=ts"
import style0 from "./LocationBanner.vue?vue&type=style&index=0&id=2d8debdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8debdc",
  null
  
)

export default component.exports